import axios, { AxiosError, AxiosInstance } from "axios"
import { Plugin } from "@nuxt/types"

declare module "vue/types/vue" {
  interface Vue {
    $axios: AxiosInstance
  }
}

declare module "@nuxt/types" {
  interface NuxtAppOptions {
    $axios: AxiosInstance
  }
}

declare module "vuex/types/index" {
  interface Store<S> {
    $axios: AxiosInstance
  }
}

const axiosPlugin: Plugin = ({ store, app }, inject) => {
  const axiosInstance = axios.create({
    baseURL: app.$env.SH_API_URL,
    timeout: 10000
  })

  axiosInstance.interceptors.request.use(config => ({
    ...config,
    headers: {
      ...config.headers,
      Authorization: `Bearer ${store.getters['user/accessToken']}`
    }
  }))

  axiosInstance.interceptors.response.use(res => res, async (error: AxiosError) => {
    if (error.config && error.response) {
      if (error.response.status === 401) {
        // TODO refresh token
        if (process.client) {
          window.location.reload()
        }
      } 
    }
  
    return Promise.reject(error)
  })

  inject('axios', axiosInstance)
}

export default axiosPlugin
